/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class OnboardAzureSourceAccountInteractiveRequestManagementGroupsInner {
  /**
  * Management group ID
  */
  'id': string;
  /**
  * Management group display name
  */
  'name'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return OnboardAzureSourceAccountInteractiveRequestManagementGroupsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

